import {firestore} from "../firebaseApp";
import {addDoc, collection,
    deleteDoc, doc, DocumentData, Firestore, FirestoreDataConverter, getDoc, QueryDocumentSnapshot,
    setDoc,
    SnapshotOptions, updateDoc, WithFieldValue} from "firebase/firestore";

export function getCollectionRef<T>(collectionName: string, converter: FirestoreDataConverter<T>) {
    return collection(firestore, collectionName).withConverter(converter);
}